import { Badge } from '../../primitives/badge';
import { Card, CardContent } from '../../primitives/card';
import { BadgeBoolean } from '../badge/badge-boolean';
import { ButtonClipboard } from '../button/button-clipboard';
import { LabelWithoutRef } from '../label/label-without-ref';

import { FORMAT, formatDateTime } from '../../utils/format-date-time';

import type { Rule } from './types';

export function SummaryCard({
  active,
  createdAt,
  description,
  id,
  modifiedAt,
  modifiedBy,
  name,
  variants = [],
}: Omit<Rule, 'value'>) {
  const variantsCount = variants.length;

  return (
    <Card>
      <CardContent className="flex flex-col items-start gap-6 py-8">
        {/* Badges */}
        <div className="flex flex-wrap gap-2">
          <Badge variant={variantsCount > 0 ? 'accent' : 'secondary'}>
            {variantsCount > 0 ? 'Regla con variantes' : 'Regla'}
          </Badge>
          {variantsCount > 0 && <Badge variant="secondary">{variantsCount} variantes</Badge>}
          <BadgeBoolean
            on={{ text: 'Activa' }}
            off={{ text: 'Inactiva' }}
            className="flex-none px-2.5 py-0.5"
            isAnimated
            value={Boolean(active)}
          />
          <Badge variant="outline">
            <span className="mr-1 text-muted-foreground">Creación:</span>
            {formatDateTime({ value: createdAt }) || '-'}
          </Badge>
          <Badge variant="outline">
            <span className="mr-1 text-muted-foreground">Modificación:</span>
            {formatDateTime({ format: FORMAT.dd_MMMM_YYYY_HH_mm, value: modifiedAt }) || '-'}
          </Badge>
          <Badge variant="outline">
            <span className="mr-1 text-muted-foreground">Autor:</span> {modifiedBy || '-'}
          </Badge>
        </div>

        {/* Additional Information */}
        <div className="space-y-2">
          <div>
            <LabelWithoutRef className="text-xs text-muted-foreground">ID</LabelWithoutRef>
            <ButtonClipboard
              className="h-auto p-0 font-normal"
              label={id}
              size="sm"
              valueToCopy={id}
              variant="link"
            />
          </div>

          <div>
            <LabelWithoutRef className="text-xs text-muted-foreground">Nombre</LabelWithoutRef>
            <p className="text-sm">{name}</p>
          </div>

          <div>
            <LabelWithoutRef className="text-xs text-muted-foreground">Descripción</LabelWithoutRef>
            <p className="text-sm">{description}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
